"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DojoGaugeScope = void 0;
class DojoGaugeScope {
    constructor(id) {
        this._id = id;
    }
    static fromId(id, strict = true) {
        const item = DojoGaugeScope._values.find((it) => it._id === id);
        if (item) {
            return item;
        }
        if (strict) {
            throw new Error(`Invalid gauge scope id: ${id}`);
        }
    }
    static fromRaw(raw, strict = true) {
        return DojoGaugeScope.fromId(raw, strict);
    }
    toString() {
        return this._id;
    }
}
exports.DojoGaugeScope = DojoGaugeScope;
/**
 * Greater than <requirement>.
 */
DojoGaugeScope.GreaterThan = new DojoGaugeScope('m');
/**
 * Less than <requirement>.
 */
DojoGaugeScope.LessThan = new DojoGaugeScope('l');
DojoGaugeScope._values = [
    DojoGaugeScope.GreaterThan,
    DojoGaugeScope.LessThan,
];
